import React, { useState } from 'react';

import Select from './Select';

const BucketSelector = ({ activeBucket, onBucketChange, bucketConfigs = [] }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Transform bucket configurations into select options
  const buckets = bucketConfigs?.map(config => ({
    value: config?.id,
    label: config?.bucketName,
    description: config?.bucketRegion ? `Region: ${config?.bucketRegion}` : 'S3 Bucket Configuration'
  })) || [];

  const handleBucketChange = (value) => {
    if (onBucketChange) {
      onBucketChange(value);
    }
    setIsOpen(false);
  };

  // Find active bucket config
  const activeBucketConfig = bucketConfigs?.find(c => c?.id === activeBucket);

  return (
    <div className="relative">
      <Select
        label="Active Bucket"
        description="Select the S3 bucket to manage"
        options={buckets}
        value={activeBucket}
        onChange={handleBucketChange}
        searchable
        className="w-full"
        placeholder={buckets?.length === 0 ? "No buckets configured" : "Select a bucket"}
        disabled={buckets?.length === 0}
      />
      {activeBucketConfig && (
        <div className="mt-4 p-4 bg-muted rounded-md">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-2 h-2 rounded-full bg-success animate-pulse" />
            <span className="text-sm font-medium text-foreground">Connected</span>
          </div>
          <p className="text-xs text-muted-foreground">
            Successfully connected to {activeBucketConfig?.bucketName}
          </p>
        </div>
      )}
      {buckets?.length === 0 && (
        <div className="mt-4 p-4 bg-destructive/10 border border-destructive/20 rounded-md">
          <p className="text-xs text-destructive">
            No S3 buckets configured. Please add a bucket in Settings.
          </p>
        </div>
      )}
    </div>
  );
};

export default BucketSelector;